/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<void>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<void>> => {
  return axios.request({
    url: `/user/activate`,
    // @ts-ignore for sm-axios
    urlTemplate: '/user/activate',
    method: 'POST',
    data: request.body,
  })
}

/**
 * activates a user
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<void>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<void> => {
  await operationWithAxiosResponse(axios, request)
}

export interface Request {
  body: {
    token?: string
    password?: string
    secretQuestion?: string
    secretAnswer?: string
    [k: string]: any
  }
}

